import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconBasketRemove = memo(({ color, ...rest }) => {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" {...rest}>
      <Path
        fill={color}
        d="M14.12 9.53L12 7.41 9.88 9.54 8.46 8.12 10.59 6 8.47 3.88l1.41-1.41L12 4.59l2.12-2.13 1.42 1.42L13.41 6l2.12 2.12-1.41 1.41M7 19a2 2 0 11.001 3.999A2 2 0 017 19m10 0a2 2 0 11.001 3.999A2 2 0 0117 19m-9.83-3.25c0 .138.112.25.25.25H19v2H7a2 2 0 01-2-2c0-.35.09-.68.25-.96l1.35-2.45L3 5H1V3h3.27l.94 2 .95 2 2.24 4.73.13.27h7.02l2.76-5 1.1-2h.01l1.74.96-3.86 7.01c-.34.62-1 1.03-1.75 1.03H8.1l-.9 1.63-.03.12z"
      />
    </Svg>
  );
});
